import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Destination } from "../destination/destination.entity";
import { Vendors } from "../vendors/vendors.entity";
import { OcaenFreightRatesEntity } from "../ocaen-freights-rates/ocean-freights-entity";

@Entity('countries')
export class Countries {

  @PrimaryGeneratedColumn("increment",{name:'country_id'})
  countryId:number;

  @Column("char",{
      nullable:false,
      length:50,
      name:"country_name"
      })
  // @Index({ unique: true })
  countryName:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      default:1,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(type => Destination, Destinations => Destinations.CountriesInfo)
  DestinationsInfo: Destination[];
  @OneToMany(type=>Vendors, vendor=>vendor.currencyInfo,{cascade: true})
  vendorInfo:Vendors[];
  @OneToMany(type => OcaenFreightRatesEntity, info => info.countryInfo, { cascade: true })
  ocaenFreightsInfo: OcaenFreightRatesEntity[];


}
